import * as React from 'react';

export const trFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_282)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#E30A17'
            />
            <mask
                id='mask0_1_282'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_282)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M18.6694 11.536L17.1201 12.3493L17.4161 10.6253L16.1628 9.40266L17.8961 9.14933L18.6694 7.58133L19.4428 9.15066L21.1761 9.404L19.9228 10.624L20.2188 12.348'
                    fill='#F1F5F9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M12.6667 14.6667C15.244 14.6667 17.3333 12.5773 17.3333 9.99999C17.3333 7.42266 15.244 5.33333 12.6667 5.33333C10.0893 5.33333 8 7.42266 8 9.99999C8 12.5773 10.0893 14.6667 12.6667 14.6667ZM14 13.3333C15.84 13.3333 17.3333 11.84 17.3333 9.99999C17.3333 8.15999 15.84 6.66666 14 6.66666C12.16 6.66666 10.6667 8.15999 10.6667 9.99999C10.6667 11.84 12.16 13.3333 14 13.3333Z'
                    fill='#F1F5F9'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_282'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
